export default __webpack_public_path__ + "static/morningwood_lockup-2ed0a15512a894ab520cca24feddafb7.png";